var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRightWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.66675 7.99967C2.66675 7.63148 2.96522 7.33301 3.33341 7.33301L12.6667 7.33301C13.0349 7.33301 13.3334 7.63149 13.3334 7.99968C13.3334 8.36787 13.0349 8.66634 12.6667 8.66634L3.33341 8.66634C2.96522 8.66634 2.66675 8.36786 2.66675 7.99967Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.52851 2.86225C7.78886 2.6019 8.21097 2.6019 8.47132 2.86225L13.138 7.52892C13.3983 7.78927 13.3983 8.21138 13.138 8.47173L8.47132 13.1384C8.21097 13.3987 7.78886 13.3987 7.52851 13.1384C7.26816 12.878 7.26816 12.4559 7.52851 12.1956L11.7238 8.00033L7.52851 3.80506C7.26816 3.54471 7.26816 3.1226 7.52851 2.86225Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightWhite);
export default __webpack_public_path__ + "static/media/arrow-right-white.06019ab0201c95438cca8d6936fc1899.svg";
export { ForwardRef as ReactComponent };